export default {"src":"/_next/static/media/flag-AR.66e222af.svg","height":18,"width":24,"blurWidth":0,"blurHeight":0};